import React from "react";
import ReactDOM from "react-dom";
import CookiesForm from "../utils/cookiepolicy";
import "./all.css";
import "./custom.css";
import currency from "./currency";

$(function () {
    currency.update();

    function toggleMenuVisibility() {
        const slideBlock = document.querySelector(".slide-block");
        slideBlock.toggleAttribute("hidden");
    }

    document.querySelector(".menu-opener").addEventListener("click", toggleMenuVisibility);
});
